var Terms = function() {
	var page = $('[data-page="terms"]');
	var comp = $('[data-component="agreement-term"]');

	function init() {
		addListeners();
	}

	function addListeners() {
		// Prossegue para a próxima etapa
		page.find('.ok').on('click', function(e) {
			e.preventDefault();

			if (comp.find('#accept').prop('checked')) {
				comp.find('#formTerms').submit();
			}
		});
	}

	return init();
}

$(document).ready(function() {
	if ($('[data-page="terms"]').length > 0) {
		new Terms();
	}
});
